import { jsxs, jsx } from "react/jsx-runtime";
import { Popover, Heading } from "@zillow/constellation-10";
import { event } from "@zillow/universal-analytics";
import React, { useCallback } from "react";
function FieldTooltip({
  title,
  body,
  interactionEventCmsInfo
}) {
  const handleOpenChange = useCallback((open) => {
    if (!interactionEventCmsInfo) return;
    if (open) {
      event({
        envelope: {
          event_type_id: "5030",
          event_type_version_id: "1",
          event_template_id: "297",
          event_template_version_id: "1"
        },
        clickstream_trigger: {
          trigger_type_nm: "interaction",
          trigger_location_nm: "cms",
          trigger_source_nm: "cms_tooltip",
          trigger_object_nm: "no_trigger_object"
        },
        semantic: {
          semantic_event_nm: "cms_open"
        },
        cms_info: interactionEventCmsInfo
      });
    } else {
      event({
        envelope: {
          event_type_id: "2051",
          event_type_version_id: "1",
          event_template_id: "126",
          event_template_version_id: "1"
        },
        clickstream_trigger: {
          trigger_type_nm: "interaction",
          trigger_location_nm: "cms",
          trigger_source_nm: "cms_tooltip",
          trigger_object_nm: "no_trigger_object"
        },
        semantic: {
          semantic_event_nm: "cms_close"
        },
        cms_info: interactionEventCmsInfo
      });
    }
  }, [interactionEventCmsInfo]);
  return /* @__PURE__ */ jsxs(React.Fragment, { children: [
    " ",
    /* @__PURE__ */ jsx(Popover, { dividers: false, css: {
      '& [data-c11n-component="Popover.Header"]': {
        borderBottom: "1px solid",
        borderColor: "border.muted"
      }
    }, header: /* @__PURE__ */ jsx(Heading, { level: 6, children: title }), body, onOpenChange: handleOpenChange })
  ] });
}
export {
  FieldTooltip as default
};
